import { render, staticRenderFns } from "./SearchDocSelect.vue?vue&type=template&id=f52ed27a&scoped=true"
import script from "./SearchDocSelect.vue?vue&type=script&lang=js"
export * from "./SearchDocSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchDocSelect.vue?vue&type=style&index=0&id=f52ed27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52ed27a",
  null
  
)

export default component.exports